<template>
  <div>
    <v-card style="background-color: #f3f3f3">
      <v-layout
        row
        wrap
        align-center
        justify-space-between
        fill-height
        class="px-3 py-2"
      >
        <v-flex xs12 sm5>
          <v-text-field
            hide-details
            v-model="search"
            label="Search choice name / product name / option name"
            prepend-icon="search"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm3>
          <v-select
            hide-details
            :items="[
              { name: 'All status', value: '2' },
              { name: 'Active', value: true },
              { name: 'Inactive', value: false },
            ]"
            item-text="name"
            item-value="value"
            v-model="filterType"
          >
          </v-select>
        </v-flex>
      </v-layout>
      <v-card class="elevation-0">
        <v-data-table
          :headers="headers"
          :loading="isLoadingData"
          :items="filterchoice"
          :pagination.sync="pagination"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.index + 1 }}</td>
            <td
              style="display: flex; justify-content: center; margin-top: 25px"
            >
              <div>
                <v-switch
                  v-model="props.item.choice_status"
                  color="primary"
                  @change="changeState(props.item)"
                ></v-switch>
              </div>
            </td>

            <td class="text-xs-center">
              {{ props.item.product_name_th }}
            </td>
            <td class="text-xs-center">
              {{ props.item.option_name_th }}
            </td>

            <td class="text-xs-center">
              {{ props.item.choice_name_th }}
            </td>
            <td class="text-xs-center">
              {{ props.item.choice_name_en ? props.item.choice_name_en : "-" }}
            </td>
            <td class="text-xs-center">
              {{ props.item.choice_name_cn ? props.item.choice_name_cn : "-" }}
            </td>
            <td class="text-xs-center">
              {{ props.item.choice_price ? props.item.choice_price : "0" }}
            </td>
          </template>
          <template slot="no-data">
            <div v-if="choiceList.length == 0" class="text-xs-center">
              No data available
            </div>
          </template>
        </v-data-table>
      </v-card>
    </v-card>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
export default {
  data: () => ({
    isLoadingData: false,
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
      },
      {
        text: "Status",
        align: "center",
        value: "choice_status",
        sortable: false,
      },
      {
        text: "Product name",
        align: "center",
        value: "product_name_th",
        sortable: false,
      },
      {
        text: "Option Name",
        align: "center",
        value: "option_name_th",
        sortable: false,
      },
      {
        text: "Choice Name TH",
        align: "center",
        value: "choice_name_th",
        sortable: false,
      },
      {
        text: "Choice Name EN",
        align: "center",
        value: "choice_name_en",
        sortable: false,
      },
      {
        text: "Choice Name CN",
        align: "center",
        value: "choice_name_cn",
        sortable: false,
      },
      {
        text: "Choice Price",
        align: "center",
        value: "choice_price",
        sortable: false,
      },
    ],
    pagination: {
      rowsPerPage: 10,
      page: 1,
      totalItems: 0,
    },
    search: "",
    switchbutton: true,
    filterType: "2",
  }),
  components: {
    ///
  },
  computed: {
    ...mapState({
      choiceList: (state) => state.fetchStoreBack.choiceList,
    }),
    filterchoice() {
      if (this.filterType == "2") {
        if (this.search == "") {
          return this.choiceList.filter((val) => true);
        } else {
          return this.choiceList.filter(
            (val) =>
              val.choice_name_th
                .toLowerCase()
                .includes(this.search.toLowerCase()) ||
              val.product_name_th
                .toLowerCase()
                .includes(this.search.toLowerCase()) ||
              val.option_name_th
                .toLowerCase()
                .includes(this.search.toLowerCase())
          );
        }
      } else {
        return this.choiceList.filter((val) => {
          return (
            val.choice_status == this.filterType &&
            (val.choice_name_th
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
              val.option_name_th
                .toLowerCase()
                .includes(this.search.toLowerCase()) ||
              val.product_name_th
                .toLowerCase()
                .includes(this.search.toLowerCase()))
          );
        });
      }
    },
  },
  mounted() {
    this.getGata();
  },
  methods: {
    async getGata() {
      this.isLoadingData = true;
      let payload = {
        province: this.$route.params.province,
        storeID: this.$route.params.store_id,
      };
      await this.$store.dispatch("fetchStoreBack/getChoiceByStore", payload);
      this.isLoadingData = false;
    },
    async changeState(item) {
      let payload = {
        choice_id: item.choice_id,
        choice_status: item.choice_status,
        province: this.$route.params.province,
      };
      await this.$store.dispatch("fetchStoreBack/changsStatusChoice", payload);
    },
  },
};
</script>
